export const ADD_CARDS_DATA = 'addCardsData';
export const DELETE_CARD_DATA_BY_KEY = 'deleteCardImage';
export const DELETE_CAROUSEL_IMAGE_BY_KEY = 'deleteCarouselCardImage';
export const DELETE_LIST_IMAGE_BY_KEY = 'deleteListCardData';
export const ADD_CARDS_DATA_DB = 'addCardsDataFromDb';
export const DELETE_CARD = 'deleteCardImage';
export const ORIGINAL_INDEX = 'addCurrentOriginalIndex';
export const ADD_ACTIONS = 'addActions';
export const RESET_REDUX_STORE = 'resetReduxStore';
export const ADD_ORIGINAL_INDEX = 'addOriginalIndex';
export const CHANGE_POSITION_ORIGINAL_INDEX =
  'changePositioninOriginalIndArray';
export const ADD_CAROUSEL_DATA = 'addCarouselData';
export const ADD_CAROUSEL_ACTION_CHOICES = 'addCarouselActionChoices';
export const ADD_APICARD_DATA = 'addAPICardData';
export const ADD_API_PARAM_DATA = 'addAPIParamData';
export const DELETE_BUTTON = 'deleteButton';
export const DELETE_BUTTON_CAROUSEL = 'deleteButtonCarousel';
export const DELETE_BUTTON_API_PARAM = 'deleteButtonAPIParam';
export const UPDATE_ACTIONS = 'updateActions';
export const UPDATE_CAROUSEL_ACTIONS = 'updateCarouselActionChoices';
export const UPDATE_API_PARAM_ACTIONS = 'updateAPIParam';
export const UPDATE_API_TEMPLATE_ACTIONS = 'updateAPITemplateAction';
export const UPDATE_THUMBNAIL_INDEX = 'updateCarouselThumbnailInd';
export const LEAVE_PAGE_TRUE = 'leavePageTrue';
export const LEAVE_PAGE_FALSE = 'leavePageFalse';
